import { useQuery } from 'react-query';

import { LanguagesService } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useFetchLanguages = () => {
  return useQuery(
    [QueryKeys.fetchLanguages],
    async () => {
      return LanguagesService.languagesControllerGetLanguages();
    },
    { staleTime: 10 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  );
};
